
App.User = DS.Model.extend
  name  : DS.attr "string"
